'use strict';

module.exports = {
  Venue: {
    NO_PHOTO: 'Venue must have at least one photo',
    NO_VALID_SPACE: 'There must be at least one valid space for a published or lite venue',
    NO_CUISINE_TYPE: 'At least one cuisine type is required to publish a venue',
    NO_CRITIQUES: 'At least one critique is required to publish a venue'
  },
  Space: {
    NO_NAME: 'Space name is required',
    NO_PHOTO: 'Space must have at least one photo',
    NO_GOOD_FOR: 'At least one "good for" is required',
    NO_DESCRIPTION: 'Space description is required',
    DESCRIPTION_TOO_SHORT: 'Space description must be at least 10 letters long',
    NO_PRIVACY: 'Privacy is required',
    NO_FOOD_BEVERAGE_MIN: 'Food & Beverage Minimum is required',
    EXTRA_HOUR_FEE_TOO_LOW: 'Extra hour fee must be greater than 0',
    NO_CAPACITY_SELECTED: 'Space seating or standing capacity must be selected',
    NO_SEATED_CAPACITY_STYLE: 'Space seated capacity style is required',
    NO_STANDING_CAPACITY_STYLE: 'Space standing capacity style is required'
  },
  Menu: {
    NO_NAME: 'Menu name is required',
    NO_PHOTO: 'Menu must have at least one photo',
    NO_TYPE: 'Menu type is required',
    NO_DESCRIPTION: 'Menu description is required',
    DESCRIPTION_TOO_SHORT: 'Menu description must be at least 10 letters long',
    NO_PRICE: 'Menu price is required'
  },
  Drink: {
    NO_ADDITIONAL_HOUR_PRICE: 'Additional hour price is required',
    NO_NAME: 'Drink package name is required',
    NO_DESCRIPTION: 'Drink package description is required',
    NO_PRICE: 'Drink package price is required',
    NO_DURATION: 'Drink package duration is required'
  },
  NO_COURSE: 'At least one course is required',
  NO_COURSE_NAME: 'Each course requires a name',
  NO_COURSE_DESCRIPTION: 'Each course requires a description',
  COURSE_DESCRIPTION_TOO_SHORT: 'Course description must be at least 10 letters long',
  'REQUIRED': 'required',
  'MIN_LENGTH': 'min_length',
  'MIN_VALUE': 'min_value',
  'EMPTY_ARRAY': 'empty_array'
};